<script>
    import { onMount } from "svelte";
    import { user } from "../../stores";
    import {
        checkTokenExpiration,
        goBack,
        signOut,
        goToURL,
    } from "../../Utils/utilFunctions.svelte";

    export let tokenRefresh = undefined;

    onMount(async () => {
        tokenRefresh = checkTokenExpiration();
    });

    const goToPrev = () => {
        const expiry = new Date($user.expiration);
        if (new Date() > expiry) {
            signOut({ reason: "Out of expiration" }, true);
            goToURL("/");
        } else goBack();
    };
</script>

<div class="flex flex-1 items-center justify-center">
    <div
        class="flex flex-1 flex-col items-center justify-center gap-y-4 p-4 rounded-lg shadow-2xl"
    >
        <p class="text-warning text-[36px] font-bold">
            PAGE NOT FOUND
        </p>
        <button
            class="btn btn-error text-white"
            on:click|preventDefault={goToPrev}>BACK</button
        >
    </div>
</div>
